import { ServerError } from './ServerError';
import type { TJSErrorParams } from './const';
import type { TServerErrorStatusCode } from './EServerErrorStatusCodes';
import { EServerErrorStatusCodes } from './EServerErrorStatusCodes';

function makeServerErrorClass(status: number) {
  return class extends ServerError {
    constructor(params: Omit<TJSErrorParams, 'name' | 'shouldSkipLogs'>) {
      super({
        ...params,
        status,
        shouldSkipLogs: false,
      });
    }
  };
}

export const KnownErrors = {
  // HTTP
  ...(() => {
    return (Object.keys(EServerErrorStatusCodes) as (TServerErrorStatusCode)[]).reduce(
      (acc, statusCode: TServerErrorStatusCode) => {
        acc[`Http_${statusCode}` as any] = makeServerErrorClass(EServerErrorStatusCodes[statusCode]);
        return acc;
      },
      {} as {
        [K in `Http_${TServerErrorStatusCode}`]: ReturnType<typeof makeServerErrorClass>;
      },
    );
  })(),
};
